import React, { useCallback, useEffect, useState } from 'react';
import { UserCheck, Loader2, Link2, X } from 'lucide-react';
import { api } from '../context/AuthContext';

const dt = (v) => (v ? new Date(v).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—');

const Zeile = ({ r, onDone }) => {
  const [mnr, setMnr] = useState(r.vorschlaege?.[0]?.mandanten_nr || '');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const verknuepfen = async (bestaetigt = false) => {
    setBusy(true); setMsg('');
    try {
      const { data } = await api.post(`/admin/registrierungen/${r.user_id}/verknuepfen`, { mandanten_nr: mnr.trim(), abweichende_email_bestaetigt: bestaetigt });
      onDone(r.user_id, `${r.email} → M-${data.mandanten_nr}${data.mandant_neu ? ' (neu angelegt)' : ''}`);
    } catch (e) {
      const d = e?.response?.data?.detail || 'Fehler';
      if (typeof d === 'string' && d.startsWith('ABWEICHENDE_EMAIL:')) {
        const [, mail, name] = d.split(':');
        if (window.confirm(`Mandant M-${mnr} (${name}) hat die E-Mail ${mail}. Trotzdem mit ${r.email} verknüpfen?`)) { setBusy(false); return verknuepfen(true); }
      } else setMsg(d);
    } finally { setBusy(false); }
  };
  const ablehnen = async () => { if (!window.confirm('Registrierung ablehnen?')) return; await api.post(`/admin/registrierungen/${r.user_id}/ablehnen`); onDone(r.user_id, ''); };
  return (
    <li className="py-3 border-b border-gray-100 last:border-0 flex flex-col md:flex-row md:items-center gap-3" data-testid={`registrierung-${r.user_id}`}>
      <div className="flex-1 min-w-0">
        <div className="text-sm text-[#1B3A5C] font-medium truncate">{r.name || '—'} · {r.email}</div>
        <div className="text-[11px] text-[#7a8a99]">registriert {dt(r.registrierung?.am || r.created_at)} · {r.auth_provider === 'google' ? 'Google' : 'E-Mail/Passwort'}{r.registrierung?.herkunft === 'bestand' ? ' · Bestandskonto (frühere E-Mail-Verknüpfung aufgehoben)' : ''}{r.anfragen ? ` · ${r.anfragen} Anfrage(n)` : ''}</div>
        {r.vorschlaege?.length > 0 && <div className="text-[11px] text-amber-800 mt-0.5">Vorschlag (gleiche E-Mail): {r.vorschlaege.map((v) => `M-${v.mandanten_nr} ${v.name || ''}`).join(', ')} – bitte prüfen</div>}
        {msg && <div className="text-[11px] text-rose-700 mt-0.5">{msg}</div>}
      </div>
      <div className="flex items-center gap-2">
        <input value={mnr} onChange={(e) => setMnr(e.target.value.replace(/\D/g, ''))} placeholder="Mandantennr. (DATEV)" className="w-52 px-3 py-2 border border-gray-200 text-sm rounded-sm focus:border-[#b8893d] focus:outline-none" data-testid={`registrierung-mnr-${r.user_id}`} />
        <button type="button" disabled={busy || !mnr} onClick={() => verknuepfen()} className="inline-flex items-center gap-1.5 bg-[#1B3A5C] text-white text-xs tracking-wider px-3 py-2 rounded-sm disabled:opacity-50" data-testid={`registrierung-verknuepfen-${r.user_id}`}>{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Link2 className="w-3.5 h-3.5" />} VERKNÜPFEN</button>
        <button type="button" onClick={ablehnen} className="p-2 text-[#7a8a99] hover:text-rose-600" aria-label="Ablehnen" data-testid={`registrierung-ablehnen-${r.user_id}`}><X className="w-4 h-4" /></button>
      </div>
    </li>
  );
};

export const AdminRegistrierungen = () => {
  const [items, setItems] = useState(null);
  const [ok, setOk] = useState('');
  const load = useCallback(() => api.get('/admin/registrierungen').then((r) => setItems(r.data.items)).catch(() => setItems([])), []);
  useEffect(() => { load(); }, [load]);
  if (!items || items.length === 0) return ok ? <p className="mb-6 text-xs text-emerald-700" data-testid="registrierung-ok">{ok}</p> : null;
  return (
    <section className="mb-8 bg-white border border-[#b8893d]/40 rounded-sm p-5" data-testid="admin-registrierungen">
      <h2 className="flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[#1B3A5C] font-semibold mb-1"><UserCheck className="w-4 h-4 text-[#b8893d]" /> Neue Registrierungen zur Freigabe ({items.length})</h2>
      <p className="text-xs text-[#34536b] mb-3">Konten sehen erst nach Verknüpfung mit der Mandantennummer aus DATEV Mandantendaten. Eine Zuordnung allein über die E-Mail erfolgt nicht.</p>
      {ok && <p className="mb-2 text-xs text-emerald-700" data-testid="registrierung-ok">{ok}</p>}
      <ul>{items.map((r) => <Zeile key={r.user_id} r={r} onDone={(id, text) => { setItems((cur) => cur.filter((x) => x.user_id !== id)); setOk(text); }} />)}</ul>
    </section>
  );
};
